import http from './api'

const url = '/email_ingest/api/emails'

export const httpGetEmails = (params) => {
  return http({
    url: `${url}/`,
    method: 'GET',
    params
  })
}

export const httpGetEmail = (id) => {
  return http({
    url: `${url}/${id}/`,
    method: 'GET',
  })
}

export const httpMarkEmailProcessed = (id) => {
  return http({
    url: `${url}/${id}/mark_processed/`,
    method: 'POST',
  })
}

export const httpMarkEmailUnprocessed = (id) => {
  return http({
    url: `${url}/${id}/mark_unprocessed/`,
    method: 'POST',
  })
}

export const httpGetEmailStats = () => {
  return http({
    url: `${url}/stats/`,
    method: 'GET',
  })
}

